import { DateRangeFilterBase } from './date-range/date-range-filter-base';
import { PresetButtons } from './date-range/preset-buttons';
import type { SystemLogsDateRangeFilterProps } from './date-range/types';

export type { DateRange, DateRangeFilterProps } from './date-range/types';

export function SystemLogsDateRangeFilter({
  value,
  onChange,
}: SystemLogsDateRangeFilterProps) {
  return (
    <div className="flex items-end gap-2">
      <DateRangeFilterBase value={value} onChange={onChange} />
      <PresetButtons onSelect={onChange} />
    </div>
  );
}
